import { Subscription } from "../libs/listeners/Subscription";
export var ExeQueueSubscription;
(function (ExeQueueSubscription) {
    ExeQueueSubscription[ExeQueueSubscription["ADDED"] = 0] = "ADDED";
})(ExeQueueSubscription || (ExeQueueSubscription = {}));
export class ExeQueue {
    constructor() {
        this._queue = [];
        this._processingQueue = false;
        this.listener = new Subscription();
    }
    push(exe, afterHtmlReady = '') {
        if (Array.isArray(exe)) {
            exe.forEach((exeItem) => {
                this.push(exeItem, afterHtmlReady);
            });
        }
        else {
            this._queue.push({
                exe,
                afterHtmlReady
            });
        }
        this.processQueue();
    }
    processQueue() {
        if (!this._processingQueue) {
            this._processingQueue = false;
            if (this._queue.length > 0) {
                const item = this._queue.shift();
                try {
                    item.exe();
                    this.listener.inform(ExeQueueSubscription.ADDED, {
                        item
                    });
                    setTimeout(() => {
                        this.processQueue();
                    }, 2);
                }
                catch (e) {
                    logger.error(e.stack);
                }
            }
        }
    }
}
